import { render, staticRenderFns } from "./ProjectTaskStatisticsTableList.vue?vue&type=template&id=d81bbf30&scoped=true"
import script from "./ProjectTaskStatisticsTableList.vue?vue&type=script&lang=js"
export * from "./ProjectTaskStatisticsTableList.vue?vue&type=script&lang=js"
import style0 from "./ProjectTaskStatisticsTableList.vue?vue&type=style&index=0&id=d81bbf30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81bbf30",
  null
  
)

export default component.exports